import Vue from "vue";
import Vuetify from "vuetify";
import {
  VCard,
  VBtn,
  VApp,
  VDivider,
  VSnackbar,
  VIcon,
  VSpacer,
  VChip,
  VCol,
  VImg,
  VRow,
} from "vuetify/lib/components";

Vue.use(Vuetify, {
  components: {
    VCard,
    VBtn,
    VApp,
    VDivider,
    VSnackbar,
    VIcon,
    VSpacer,
    VChip,
    VCol,
    VImg,
    VRow,
  },
});

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#2b94fc",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
      },
    },
  },
  icons: {
    iconfont: "mdi",
  },
});
